import { DeclarativeField, IdtComponentCmsDefinition, IdtComponentSettings } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function buildDeclarativeDefinition(id: string, json: any): IdtComponentDefinition { // TODO: remove json
  return {
    id,
    role: IdtComponentRole.Piece,
    numSlots: 0
  };
}

export function buildDeclarativeCmsDefinition(json: any): IdtComponentCmsDefinition {
  const fields = json.fields as DeclarativeField[];
  const analytics = json.analytics as string[];
  const empty = {} as IdtComponentSettings;
  const disableStyles = json.disableStyles as string[];

  return {
    name: json.description,
    group: json.group,
    availablePlatforms: json.availablePlatforms,
    isDeprecated: json.isDeprecated,
    isNew: json.isNew,
    isOnlyAvailableWithCollections: json.isOnlyAvailableWithCollections,
    initialSettings: () => empty,
    fields,
    analytics,
    disableStyles
  } as IdtComponentCmsDefinition;
}
